export default __webpack_public_path__ + "static/media/loader.5265fa35.gif";